import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { UrlContext } from "../../../contexts/UrlContext";
import CalendarForTimeSlot from "./calendarForTimeSlot";
import CallDeatils from "./callDetails";
import { DayPilot } from "@daypilot/daypilot-lite-react";
import ModifySlot from "./modifySlot";

export default function SuggestTimeSlot({
  projectID,
  expertID,
  profile,
  singleExpert,
  setSingleExpert,
  allExpert,
  setAllExpert,
  setIsCalendarOpen,
  fromRequest,
  setFromRequest,
  setShowSelectProfile,
  refreshEvent,
  setRefreshEvent,
}) {
  const { API_URL } = useContext(UrlContext);
  const [events, setEvents] = useState([]);
  const [modifyOpen, setModifyOpen] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [eventsChanged, setEventsChanged] = useState(false);
  const handleCloseNewEventModal = () => {
    setModifyOpen(false);
  };
  const eventToString = (selectedEvent) => {
    const selectedTimeSlot = {
      weekday: new Intl.DateTimeFormat("en-GB", { weekday: "long" }).format(
        new Date(selectedEvent.startTime)
      ),
      day: new Intl.DateTimeFormat("en-GB", { day: "2-digit" }).format(
        new Date(selectedEvent.startTime)
      ),
      month: new Intl.DateTimeFormat("en-GB", { month: "long" }).format(
        new Date(selectedEvent.startTime)
      ),
      year: new Intl.DateTimeFormat("en-GB", { year: "numeric" }).format(
        new Date(selectedEvent.startTime)
      ),
      startTime: new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(new Date(selectedEvent.startTime)),
      endTime: new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(new Date(selectedEvent.endTime)),
    };
    return `${selectedTimeSlot.weekday}, ${selectedTimeSlot.day} ${selectedTimeSlot.month} ${selectedTimeSlot.year} ${selectedTimeSlot.startTime} - ${selectedTimeSlot.endTime} (${selectedEvent.timezone})`;
  };

  const callToString = (selectedEvent) => {
    const selectedTimeSlot = {
      weekday: new Intl.DateTimeFormat("en-GB", { weekday: "long" }).format(
        new Date(selectedEvent.startTime)
      ),
      day: new Intl.DateTimeFormat("en-GB", { day: "2-digit" }).format(
        new Date(selectedEvent.startTime)
      ),
      month: new Intl.DateTimeFormat("en-GB", { month: "long" }).format(
        new Date(selectedEvent.startTime)
      ),
      year: new Intl.DateTimeFormat("en-GB", { year: "numeric" }).format(
        new Date(selectedEvent.startTime)
      ),
      startTime: new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(new Date(selectedEvent.startTime)),
      endTime: new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(new Date(selectedEvent.endTime)),
    };
    return `${selectedTimeSlot.weekday}, ${selectedTimeSlot.day} ${selectedTimeSlot.month} ${selectedTimeSlot.year} ${selectedTimeSlot.startTime} - ${selectedTimeSlot.endTime} (Europe/Berlin)`;
  };

  // API for fetching meeting timeslots
  const getMeetingSlots = async () => {
    const requestBody = {
      projectID: projectID,
      expertID: expertID,
    };
    try {
      let modifiedUrl = "get-client-meeting-timeslots";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setEvents(responseData.eventData);
      } else {
        console.error("Failed to add selected slot");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  // API for fetching meeting timeslots
  const getExpertClientSlots = async () => {
    const requestBody = {
      projectID: projectID,
      expertID: expertID,
    };
    try {
      let modifiedUrl = "get-expert-client-timeslots";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setEvents(responseData.eventData);
      } else {
        console.error("Failed to add selected slot");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  useEffect(() => {
    if (singleExpert) {
      getExpertClientSlots();
      console.log("get single expert events");
    } else if (allExpert) {
      console.log("get all events");
      getMeetingSlots();
    } else {
      getMeetingSlots();
      console.log("get single expert events");
    }
  }, []);

  // API for remove expert from selected list
  const deleteEvent = async (selectedEvent) => {
    Swal.fire({
      title: "Delete this time slot?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const updatedEvents = events.filter(
          (event) => event.eventID !== selectedEvent.eventID
        );

        const requestBody = {
          eventID: selectedEvent.eventID,
        };

        try {
          let modifiedUrl = "delete-meeting-time-slot";
          const response = await fetch(`${API_URL}${modifiedUrl}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });

          const responseData = await response.json();
          if (responseData.status === "success") {
            setEvents(updatedEvents);
            setEventsChanged(true);

            Swal.fire({
              title: "Deleted!",
              text: "Selected time slot has been deleted",
              icon: "success",
              timer: 2500,
              timerProgressBar: true,
            });
          } else {
            console.error("Failed to delete the slot");
            // setLoading(false);
            Swal.fire({
              title: "Error!",
              text: responseData.text,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error while calling the backend API:", error);
          // setLoading(false);
          Swal.fire({
            title: "Error!",
            text: "Unexpected error!",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  // API for fetching meeting timeslots
  const requestForCall = async () => {
    const requestBody = {
      projectID: projectID,
      expertID: expertID,
      client: true,
    };
    try {
      let modifiedUrl = "request-for-call";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setRefreshEvent(!refreshEvent);
        Swal.fire({
          title: "Thank you!",
          text: "We will schedule a call as soon as posible.",
          icon: "success",
          confirmButtonText: "OK",
          timer: 5000,
          timerProgressBar: true,
        });
      } else {
        console.error("Failed to add selected slot");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  return (
    <>
      <div className="decline-wrapper">
        <div
          className="flex-container-decline-profile"
          style={{
            width: "98%",
            height: "72%",
            overflow: "hidden",
            padding: "0px",
          }}
        >
          <div
            className="flex-item-decline-profile-header"
            style={{ flex: "2%", backgroundColor: "#365561" }}
          >
            <p
              style={{
                fontSize: "16px",
                fontWeight: "500",
                marginLeft: "5px",
                color: "white",
              }}
            >
              Suggest Time Slots
            </p>
            <i
              class="fa-solid fa-xmark"
              style={{
                marginRight: "5px",
                marginTop: "3px",
                color: "gray",
                cursor: "pointer",
              }}
              onClick={() => {
                if (events.length === 0) {
                  setIsCalendarOpen(false);
                } else if (fromRequest) {
                  setIsCalendarOpen(false);
                } else {
                  setShowSelectProfile(true);
                }
                setAllExpert(false);
                setSingleExpert(false);
                setFromRequest(false);
              }}
            />
          </div>
          <div
            className="flex-item-sugest-time-slot-calendar"
            style={{ flex: "98%", paddingTop: "5px" }}
          >
            <div
              className="flex-container-suggest-time-slot-container"
              style={{ display: "flex", flexDirection: "row" }}
            >
              <div
                className="flex-item-suggest-time-slot-container-item-calendar"
                style={{ flex: "70%" }}
              >
                <CalendarForTimeSlot
                  events={events}
                  setEvents={setEvents}
                  setEventsChanged={setEventsChanged}
                  projectID={projectID}
                  expertID={expertID}
                />
              </div>
              <div
                className="flex-item-suggest-time-slot-container-item-slot-list"
                style={{
                  flex: "30%",
                  marginLeft: "10px",
                  borderLeft: "1px solid lightgray",
                }}
              >
                {fromRequest ? (
                  <>
                    <div
                      className="flex-container-suggest-time-slot-container-item-slot-list-container"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <div
                        style={{
                          flex: "10%",
                          textAlign: "center",
                          borderBottom: "1px solid lightgray",
                        }}
                      >
                        <p
                          style={{
                            fontWeight: "500",
                            margin: "10px 0px 10px 0px",
                          }}
                        >
                          Selected Timeslots For Call
                        </p>
                        <p>
                          {"(double click and scroll to select multiple slots)"}
                        </p>
                      </div>
                      <div
                        className="display-selected-time-slots"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "500px",
                          overflow: "auto",
                        }}
                      >
                        <div style={{ flex: "80%", padding: "10px" }}>
                          {events.map((event, index) => (
                            <>
                              {event.eventType === "consultantTimeSlot" && (
                                <div
                                  key={index}
                                  style={{
                                    background: "#E8F5E9",
                                    borderLeft: "10px solid #46923c",
                                    marginBottom: "15px",
                                    boxShadow: "0 0 10px #bab6b6",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div>
                                    <p
                                      style={{
                                        padding: "10px 10px 0px 10px",
                                        fontSize: "16px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Your given availability!
                                    </p>
                                    <p
                                      style={{
                                        padding: "0px 0px 10px 10px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {eventToString(event)}
                                    </p>
                                  </div>
                                  <i
                                    class="fa-solid fa-xmark"
                                    style={{
                                      marginRight: "5px",
                                      color: "lightgray",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => deleteEvent(event)}
                                  ></i>
                                </div>
                              )}
                            </>
                          ))}
                        </div>
                      </div>
                      <div
                        onClick={() => {
                          setIsCalendarOpen(false);
                          setFromRequest(false);
                          requestForCall();
                        }}
                        style={{
                          flex: "10%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "1px solid lightgrey",
                          cursor: "pointer",
                          color: "#365561",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          width="24"
                          height="24"
                          viewBox="0 0 55 55"
                          fill="currentcolor"
                          style={{ marginLeft: "-1px" }}
                        >
                          <path d="M 27.5 5 C 24.08 5 21.269531 7.64 21.019531 11 L 24 11 C 26.76 11 29 13.24 29 16 L 29 17.820312 C 31.87 17.150312 34 14.57 34 11.5 C 34 7.91 31.09 5 27.5 5 z M 42.5 9 A 4.5 4.5 0 0 0 42.5 18 A 4.5 4.5 0 0 0 42.5 9 z M 6 13 C 4.346 13 3 14.346 3 16 L 3 34 C 3 35.654 4.346 37 6 37 L 24 37 C 25.654 37 27 35.654 27 34 L 27 16 C 27 14.346 25.654 13 24 13 L 6 13 z M 10 19 L 20 19 L 20 21 L 16 21 L 16 31 L 14 31 L 14 21 L 10 21 L 10 19 z M 29 21 L 29 34 C 29 36.76 26.76 39 24 39 L 18.199219 39 C 18.599219 40.96 19.569688 42.710313 20.929688 44.070312 C 22.739688 45.880312 25.24 47 28 47 C 33.52 47 38 42.52 38 37 L 38 21 L 29 21 z M 40 21 L 40 37 C 40 37.82 39.919531 38.620625 39.769531 39.390625 C 40.599531 39.780625 41.52 40 42.5 40 C 46.09 40 49 37.09 49 33.5 L 49 21 L 40 21 z"></path>
                        </svg>
                        <p
                          style={{
                            fontWeight: "500",
                            padding: "10px 0px 10px 0px",
                          }}
                        >
                          Request Call
                        </p>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="flex-container-suggest-time-slot-container-item-slot-list-container"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <div
                        style={{
                          flex: "10%",
                          textAlign: "center",
                          borderBottom: "1px solid lightgray",
                        }}
                      >
                        <p style={{ fontWeight: "500" }}>Selected Time Slots</p>
                        <p>
                          {"(double click and scroll to select multiple slots)"}
                        </p>
                      </div>
                      <div
                        className="display-selected-time-slots"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "540px",
                          overflow: "auto",
                        }}
                      >
                        <div style={{ flex: "80%", padding: "10px" }}>
                          {events.map((event, index) => (
                            <>
                              {event.eventType === "consultantTimeSlot" ? (
                                <div
                                  key={index}
                                  onClick={() => {
                                    setSelectedSlot(event);
                                    setModifyOpen(true);
                                  }}
                                  style={{
                                    background: "#E8F5E9",
                                    borderLeft: "10px solid #46923c",
                                    marginBottom: "15px",
                                    boxShadow: "0 0 10px #bab6b6",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div>
                                    <p
                                      style={{
                                        padding: "10px 10px 0px 10px",
                                        fontSize: "16px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Your given availability!
                                    </p>
                                    <p
                                      style={{
                                        padding: "0px 0px 10px 10px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {eventToString(event)}
                                    </p>
                                  </div>
                                  <i
                                    class="fa-solid fa-xmark"
                                    style={{
                                      marginRight: "5px",
                                      color: "lightgray",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      deleteEvent(event);
                                    }}
                                  ></i>
                                </div>
                              ) : (
                                <>
                                  {event.eventType === "TeamsCall" ? (
                                    <div
                                      key={index}
                                      onClick={() => {
                                        setSelectedSlot(event);
                                        setShowDetails(true);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        background: "#a5ccdb",
                                        borderLeft: "10px solid #365561",
                                        marginBottom: "15px",
                                        boxShadow: "0 0 10px #bab6b6",
                                      }}
                                    >
                                      <p
                                        style={{
                                          padding: "10px 10px 0px 10px",
                                          fontSize: "16px",
                                          fontWeight: "500",
                                          display: "-webkit-box",
                                          WebkitLineClamp: "1",
                                          WebkitBoxOrient: "vertical",
                                          overflow: "hidden",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {event.inviteTitle}
                                      </p>
                                      <p
                                        style={{
                                          padding: "0px 0px 10px 10px",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {callToString(event)}
                                      </p>
                                    </div>
                                  ) : null}
                                </>
                              )}
                            </>
                          ))}
                        </div>
                      </div>
                      <div
                        onClick={() => {
                          if (eventsChanged) {
                            fetch(
                              `${API_URL}client-availability-log/${projectID}`,
                              {
                                method: "GET",
                                headers: {
                                  "Content-Type": "application/json",
                                },
                              }
                            );
                          }
                          if (events.length === 0) {
                            setIsCalendarOpen(false);
                          } else if (fromRequest) {
                            setIsCalendarOpen(false);
                          } else {
                            setShowSelectProfile(true);
                          }
                          setAllExpert(false);
                          setSingleExpert(false);
                          setFromRequest(false);
                        }}
                        style={{
                          flex: "10%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "1px solid lightgrey",
                          cursor: "pointer",
                        }}
                      >
                        <p style={{ fontWeight: "500" }}>Save & close</p>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {modifyOpen && (
        <ModifySlot
          eventData={selectedSlot}
          setEvents={setEvents}
          setEventsChanged={setEventsChanged}
          onClose={handleCloseNewEventModal}
        />
      )}

      {showDetails && (
        <CallDeatils
          event={selectedSlot}
          profile={profile}
          setShowDetails={setShowDetails}
        />
      )}
    </>
  );
}
